<template>
  <div class="page_box">
    <BaseBanner :bannerInfo.sync="bannerInfo"></BaseBanner>
    <BaseModule :moduleInfo.sync="moduleInfo1">
      <ul class="module_body module_body_1">
        <div class>{{list1.text1}}</div>
        <div class="text2_con">{{list1.text2}}</div>
        <div class="flex_items_around">
          <li class="num_item" v-for="(item,index) in list1.list" :key="index+'_1'">
            <div class="num">{{item.num}}</div>
            <div>{{item.text}}</div>
          </li>
        </div>
      </ul>
    </BaseModule>
    <BaseModule :moduleBg.sync="moduleBg" :moduleInfo.sync="moduleInfo2">
      <ul class="module_body flex module_body_2">
        <li class="module_item module_item_2" v-for="(item,index) in list2" :key="index+'_1'">
          <img :src="item.img" alt />
          <div>{{item.text}}</div>
          <!-- <div class="module_item_text">
            <div class="module_item_text_title">{{item.title}}</div>
            <div>{{item.text}}</div>
          </div>-->
        </li>
      </ul>
    </BaseModule>
    <BaseModule :moduleInfo.sync="moduleInfo3">
      <ul class="module_body module_body_1">
        <div class>{{list3.text1}}</div>
      </ul>
    </BaseModule>
  </div>
</template>
<script>
export default {
  data() {
    return {
      moduleBg: true,
      bannerInfo: {
        img: require("@img/about/banner.png"),
        desc: {
          title: this.$t("about.bannerTitle"),
          text: this.$t("about.text1"),
        },
      },
      moduleInfo1: {
        title: this.$t("about.module1.title"),
        desc: {
          text1: "",
        },
      },
      list1: {
        text1: this.$t("about.moduleList1.text1"),
        text2: this.$t("about.moduleList1.text2"),
        list: [
          {
            text: this.$t("about.moduleList1.text3"),
            num: "150+",
          },
          {
            text: this.$t("about.moduleList1.text4"),
            num: "20+",
          },
          {
            text: this.$t("about.moduleList1.text5"),
            num: "10+",
          },
        ],
      },
      moduleInfo2: {
        title: this.$t("about.module2.title"),
        desc: {
          text1: "",
        },
      },
      list2: [
        {
          img: require("@img/about/icon1_about.png"),
          text: this.$t("about.moduleList2.text1"),
        },
        {
          img: require("@img/about/icon2_about.png"),
          text: this.$t("about.moduleList2.text2"),
        },
        {
          img: require("@img/about/icon3_about.png"),
          text: this.$t("about.moduleList2.text3"),
        },
        {
          img: require("@img/about/icon4_about.png"),
          text: this.$t("about.moduleList2.text4"),
        },
      ],
      moduleInfo3: {
        title: this.$t("about.module3.title"),
        desc: {
          text1: "",
        },
      },
      list3: {
        text1: this.$t("about.moduleList3.text1"),
      },
    };
  },
};
</script>

<style lang="less" scoped>
.page_box {
  .module_body_1 {
    color: @fontColorDesc;
    line-height: 34px;
    font-size: 14px;
    .text2_con {
      margin: 10px 0 50px 0;
    }
    .num_item {
      text-align: center;

      .num {
        font-size: 32px;
        color: @blackColor;
      }
    }
  }

  .module_body_2{
      justify-content: space-between;

    .module_item_2{
      width: 22%;
      background-color: #ffffff;
      padding: 50px 10px;
      box-sizing: border-box;
      text-align: center;
      border-radius: 4px;

      >img{
        margin-bottom: 10px;
      }
    }

  }
}
</style>
